const states = {
    agent_details: {
        agents: [],
        active_agent: {},
        agents_loading: false,
        agents_load_error: false
    }
}

export default states